import { round } from "../../../utils/utils"
import { EmptyCell } from "./EmptyCell"

export const SimpleRoundedValueLabel = ({ value }) => {
  if (!value) return <EmptyCell />
  const formatted = round(value)
  return <span>{formatted.toLocaleString("pt-br")}</span>
}
